import { render, staticRenderFns } from "./DraftCurriculumListItem.vue?vue&type=template&id=4e66b8d2&scoped=true&lang=pug"
import script from "./DraftCurriculumListItem.vue?vue&type=script&lang=js"
export * from "./DraftCurriculumListItem.vue?vue&type=script&lang=js"
import style0 from "./DraftCurriculumListItem.vue?vue&type=style&index=0&id=4e66b8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66b8d2",
  null
  
)

export default component.exports